import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { columns } from './table-config'
import { LuxDataTable } from '@lux/wardrobe-lib'
import { FilterMatchMode } from 'primereact/api'
import { FormProps, ResourceProps } from '@/app/models/new-resource'
import { ProjectsService } from '@/app/services/ProjectsService'
import './FormList.scss'
import { connect } from 'react-redux'
import { downloadSurveyList } from '@/app/redux/actions/activity-execution'

const FormList = (props: {
    referenceObjectFolder: ResourceProps
    selectedForms: FormProps[]
    setSelectedForms: (selectedForms: FormProps[]) => void
    downloadFormList?: (banner: string[], country: string[]) => void
    banner: string[]
    country: string[]
    region: string[]
}) => {
    const { selectedForms, banner, country, region, setSelectedForms, downloadFormList } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-resource-form-list'

    const [formList, setFormList] = useState<FormProps[]>([])

    const [filters, setFilters] = useState({
        formName: {
            value: '',
            matchMode: FilterMatchMode.CONTAINS,
            onChange: (v) => onChangeFilter(v, 'formName'),
        },
        formType: {
            value: '',
            matchMode: FilterMatchMode.CONTAINS,
            onChange: (v) => onChangeFilter(v, 'formType'),
        },
    })

    const onChangeFilter = (value, field) => {
        setFilters({
            ...filters,
            [field]: { ...filters[field], value: value },
        })
    }

    useEffect(() => {
            ProjectsService.GetFormList(banner, region, country)
                .then((res: any) => {
                    if (res && res.data && res.data.surveys) {
                        setFormList(
                            res.data.surveys.map((survey: any) => ({
                                ...survey,
                                disabled: false,
                            }))
                        )
                    } else {
                        setFormList([])
                    }
                })
                .catch((error: any) => {
                    setFormList([])
                })
    }, [banner, country, region])

    const onSelectedRows = (selectedRows: any) => {
        if (selectedRows) {
            setSelectedForms([selectedRows])
        } else {
            setSelectedForms([])
        }
    }

    return (
        <div className={componentClass}>
            <LuxDataTable
                label={intl.formatMessage({
                    id: 'modals.new_resource.label.form_list',
                    defaultMessage: 'Form List',
                })}
                mandatory={true}
                selectionMode={'single'}
                columns={columns.map((column) => ({
                    ...column,
                    header: column.header
                        ? intl.formatMessage({
                              id: column.header,
                              defaultMessage: column.header.split('.').pop(),
                          })
                        : '',
                }))}
                rowsPerPageOptions={[5, 10, 15]}
                dataSet={formList}
                scrollable
                selectedRows={selectedForms}
                setSelectedRows={(value) => onSelectedRows(value)}
                actionsList={[
                    {
                        icon: 'caret-right',
                        command: (e) => window.open(e.surveyUrl, '_blank'),
                    },
                ]}
                dataKey={'surveyId'}
                columnFilters={filters}
                labels={{
                    filter: intl.formatMessage({
                        id: 'modals.new_resource.distribution.store_list.filter',
                        defaultMessage: 'filter',
                    }),
                    rearrange: intl.formatMessage({
                        id: 'modals.new_resource.distribution.store_list.rearrange',
                        defaultMessage: 'rearrange',
                    }),
                    of: intl.formatMessage({
                        id: 'modals.new_resource.distribution.store_list.labels.of',
                        defaultMessage: 'of',
                    }),
                    selected: intl.formatMessage({
                        id: 'modals.new_resource.distribution.store_list.labels.selected',
                        defaultMessage: 'selected',
                    }),
                    emptyMessage: intl.formatMessage({
                        id: 'modals.new_resource.distribution.store_list.labels.emptyMessage',
                        defaultMessage: 'No results to show.',
                    }),
                }}
                onDownload={() => downloadFormList(banner, country)}
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({
    downloadFormList: (banner, country) => dispatch(downloadSurveyList(banner, country, 'FORM')),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormList)
